
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12.529","height":"13.698"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-2 -1)","fill":"none","stroke":"#a2a2a2","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('rect',{attrs:{"data-name":"Rectangle 5742","width":"10.529","height":"10.529","rx":"2","transform":"translate(3 3.17)"}}),_c('path',{attrs:{"data-name":"Line 1211","d":"M10.604 2v2.34"}}),_c('path',{attrs:{"data-name":"Line 1212","d":"M5.925 2v2.34"}}),_c('path',{attrs:{"data-name":"Line 1213","d":"M3 6.679h10.529"}})])])
          )
        }
      }
    